import React from 'react'
import {connect} from 'react-redux'
import {Col, Divider, Form, Input, message, Row, Select, Spin, Switch, Typography} from 'antd'
import {EditOutlined, FileAddOutlined} from '@ant-design/icons'
import {withRouter} from 'react-router'

import {validateMessages} from '../../app/util'
import FormErrorMessage from '../../component/base/FormErrorMessage'
import FormButton from '../../component/base/FormButton'
import {getArtwork, getArtworkAdmin} from '../../api/artworks'
import {getArtworkCollectionById, patchArtworkCollection, postArtworkCollection} from '../../api/artworkCollections'
import HttpError from '../../component/base/HttpError'
import ArtworkDisplayOrderPanel from '../../component/ArtworkDisplayOrderPanel'
import {URL_COLLECTIONS} from '../../const'
import ArtworkSelectionPanel from "../../component/base/ArtworkSelectionPanel";
import {is_admin_user} from "../../app/role";
import {RequiredTitle} from "../../component/piece/common";

const {Title, Text} = Typography

@connect((state) => ({
    userId: state.user.info.id,
    email: state.user.info.email,
    artistId: state.user.info.artistId,
    role: state.user.info.role,
    artists: state.artist.artistNames
}))
class NewCollection extends React.Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.state = {
            loading: false,
            validateError: [],
            initTargetKeys: [],
            targetKeys: [],
            dataSource: [],
            showImage: true
        }
        this.updatedArtworkOrders = null
    }

    getCollectionId = () => {
        let id = this.props.match.params.id
        if (!id) {
            const locationArry = this.props.location.pathname.split('/')
            if (locationArry.length > 0) {
                if (locationArry[locationArry.length - 1]) {
                    id = parseInt(locationArry[locationArry.length - 1])
                } else {
                    id = parseInt(locationArry[locationArry.length - 2])
                }
            }
        }
        return id
    }

    componentDidMount() {
        if (this.props.new !== true) {
            const id = this.getCollectionId()
            Promise.all([getArtworkCollectionById(id)])
                .then((results) => {
                    const artworkCollection = results[0].data
                    this.formRef?.current.setFieldsValue({
                        title: artworkCollection.title,
                        hide_collection: !artworkCollection.is_visible
                    })
                    let order_array = null
                    try {
                        order_array = JSON.parse(artworkCollection.artworks_order_json)
                        if (!(order_array instanceof Array)) {
                            let array = []
                            Object.keys(order_array).forEach((key) => {
                                let dict = {}
                                dict[key.toString()] = order_array[key]
                                array.push(dict)
                            })
                            order_array = array
                        }
                        let order_json = {}
                        order_array.forEach((order) => {
                            Object.keys(order).forEach((key) => {
                                order_json[key] = order[key]
                            })
                        })
                        artworkCollection.artworks.sort((a, b) => {
                            return order_json[b] - order_json[a]
                        })
                    } catch (e) {
                        console.log(e)
                    }
                    this.setState({
                        loading: false,
                        artworks_orders: order_array,
                        initTargetKeys: artworkCollection.artworks,
                        targetKeys: artworkCollection.artworks
                    })
                })
                .catch((error) => {
                    this.setState(
                        {
                            loading: false
                        },
                        () => {
                            HttpError(error)
                        }
                    )
                })
        }
    }

    onRequestData = (pageId, pageSize, sort, filters, search) => {
        const requsetFunc = is_admin_user(this.props) ? getArtworkAdmin : getArtwork
        return requsetFunc(pageId, pageSize, sort, search, this.props.artistId, filters)
    }

    onFinishFailed = ({values, errorFields, outOfDate}) => {
        this.setState({validateError: errorFields})
    }

    onFinish = (values) => {
        if (this.state.targetKeys.length === 0) {
            this.setState({
                validateError: [
                    {
                        name: 'image',
                        errors: ["Selected pieces can't be blank"]
                    }
                ]
            })
            return
        }
        const {title, hide_collection} = values
        const params = {
            title,
            is_visible: !hide_collection,
            artworks: this.state.targetKeys
        }
        if (this.props.artistId) {
            params['artist'] = this.props.artistId
        }else{
            params['artist'] = values['artist']
        }
        if (this.props.new === true) {
            params['artworks_order_json'] = JSON.stringify(
                this.state.targetKeys.reduce((acc, key, index, array) => {
                    acc[key] = array.length - index
                    return acc
                }, {})
            )
            postArtworkCollection(params)
                .then((response) => {
                    message.success('Save successfully').then((r) => {
                    })
                    this.props.history.push({pathname: URL_COLLECTIONS})
                })
                .catch((error) => {
                    HttpError(error)
                })
        } else {
            if (this.updatedArtworkOrders && this.updatedArtworkOrders.length !== 0) {
                params['artworks_order_json'] = JSON.stringify(this.updatedArtworkOrders)
            }
            const id = this.getCollectionId()
            patchArtworkCollection(id, params)
                .then((response) => {
                    message.success('Save successfully', 1).then((r) => this.props.history.push({pathname: URL_COLLECTIONS}))
                })
                .catch((error) => {
                    HttpError(error)
                })
        }
    }

    render() {
        return (
            <Spin size='large' spinning={this.state.loading}>
                <Row align='bottom' gutter={{xs: 8, sm: 16, md: 24}}>
                    <Col>
                        <Title level={2} style={{marginBottom: 0}}>
                            {this.props.new === true ? <FileAddOutlined/> : <EditOutlined/>}
                            {this.props.new === true ? ' New' : ' Edit'} Collection
                        </Title>
                    </Col>
                </Row>
                <FormErrorMessage error={this.state.validateError}/>
                <Form
                    colon={false}
                    ref={this.formRef}
                    labelAlign='left'
                    onFinish={this.onFinish}
                    validateMessages={validateMessages}
                    onFinishFailed={this.onFinishFailed}
                    style={{marginTop: '32px', paddingLeft: '4%', paddingRight: '4%'}}
                    initialValues={{
                        collection: false
                    }}
                >
                    {is_admin_user(this.props) && !this.props.artistId && (
                        <>
                            <Form.Item name='artist' style={{paddingLeft: 24}} label={RequiredTitle('Artist')} rules={[{required: true}]}>
                                <Select
                                    style={{maxWidth: '80%'}}
                                    showSearch
                                    optionFilterProp='label'
                                    placeholder='Please select artist'
                                    options={this.props.artists?.map((artist) => ({
                                        value: artist.artist_id,
                                        label: artist.name
                                    }))}
                                    disabled={!this.props.new}
                                />
                            </Form.Item>
                            <Divider orientation='left'/>
                        </>
                    )}
                    <Form.Item
                        name='title'
                        label='Name'
                        rules={[
                            {
                                min: 1,
                                max: 100,
                                type: 'string',
                                required: true
                            }
                        ]}
                        style={{paddingLeft: 24}}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item name='hide_collection' valuePropName='checked'>
                        <span style={{paddingRight: 4, paddingLeft: 24}}>Is a private collection?</span>
                        <Switch/>
                    </Form.Item>
                    <Divider/>
                    <ArtworkSelectionPanel artistId={this.props.artistId}
                                           initTargetKeys={this.state.initTargetKeys}
                                           requestData={this.onRequestData}
                                           onDataSourceChange={(source) => {
                                               this.setState({
                                                   dataSource: source
                                               })
                                           }}
                                           onTargetKeysChange={(keys) => {
                                               this.setState({
                                                   targetKeys: keys
                                               })
                                           }}/>
                    <Divider style={{marginTop: 12, marginBottom: 12}}/>
                    <Title level={5} style={{marginBottom: 12}}>
                        Arrange artworks
                    </Title>
                    <ArtworkDisplayOrderPanel
                        artworks={this.state.dataSource.filter((item) => {
                            return this.state.targetKeys.includes(item.key)
                        })}
                        artworks_orders={this.state.artworks_orders}
                        onOrderChange={(order_array) => {
                            this.updatedArtworkOrders = order_array
                        }}
                    />

                    <FormButton
                        saveBtnTitle={this.props.new === true ? 'Create collection' : 'Update collection'}></FormButton>
                </Form>
            </Spin>
        )
    }
}

export default withRouter(NewCollection)
